import React from 'react';
import { Select, SelectProps } from '../../../../../../CommonComponents/OPL/Select/Select/Select';
import { SchoolOption, useSearchSchoolsSelect } from './useSearchSchoolsSelect';

interface Props extends SelectProps<SchoolOption, false> {
  clientId: string;
}

export const SearchSchoolsSelect = ({ clientId, ...rest }: Props) => {
  const { loadSchools } = useSearchSchoolsSelect({ clientId });

  return <Select isAsync cacheOptions loadOptions={loadSchools} isPortal {...rest} />;
};
